module.exports = __webpack_public_path__ + "img/ltkworkwear-1x.a0cf318.jpg";